import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  ref: "sessionsEditor",
  novalidate: "",
  class: "tray-theme-editor__settings-editor",
  enctype: "multipart/form-data"
}
const _hoisted_2 = { class: "tray-theme-editor__settings-editor__header" }
const _hoisted_3 = { class: "tray-theme-editor__settings-editor__content" }
const _hoisted_4 = { class: "tray-theme-editor__settings-editor__actions" }
const _hoisted_5 = { class: "tray-theme-editor__settings-editor__actions-wrapper" }
const _hoisted_6 = { class: "tray-theme-editor__settings-editor__actions-title" }
const _hoisted_7 = { class: "tray-theme-editor__title" }
const _hoisted_8 = {
  key: 0,
  ref: "configDevSession",
  class: "tray-theme-editor__settings-editor__menu menu-my24"
}
const _hoisted_9 = { class: "tray-theme-editor__settings-editor__description" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", { class: "separator-hr separator-hr__mx0" }, null, -1)
const _hoisted_11 = { class: "tray-theme-editor__settings-editor__description description-my12" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", { class: "separator-hr separator-hr__mx0" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Fields = _resolveComponent("Fields")!
  const _component_SubSession = _resolveComponent("SubSession")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Icon, {
              name: "arrow-left",
              prefix: "fa",
              "aria-hidden": "true",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('set-component', 'SettingsEditor')))
            }),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('layout-editor.edit-options')), 1)
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_Icon, {
              name: "times-circle",
              "aria-hidden": "true",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
            })
          ])
        ]),
        _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.getSession.label), 1),
        (_ctx.getSession.sessions && _ctx.getSession.sessions.length === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSession.sessions, (session, index) => {
                return (_openBlock(), _createBlock(_component_SubSession, {
                  key: index,
                  "title-subsession": session.label,
                  "dropdown-button": false,
                  content: true,
                  dropdown: session.label
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_9, _toDisplayString(session.description), 1),
                      _hoisted_10
                    ], 512), [
                      [_vShow, session.description]
                    ]),
                    _createVNode(_component_Fields, {
                      fields: session.fields
                    }, null, 8, ["fields"])
                  ]),
                  _: 2
                }, 1032, ["title-subsession", "dropdown"]))
              }), 128))
            ], 512))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              ref: "configDevSession",
              class: "tray-theme-editor__settings-editor__menu",
              onScroll: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.listenForElementScrollEvent && _ctx.listenForElementScrollEvent(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSession.sessions, (session) => {
                return (_openBlock(), _createBlock(_component_SubSession, {
                  key: session.label,
                  dropdown: _ctx.dropdown,
                  "onUpdate:dropdown": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dropdown) = $event)),
                  "title-subsession": session.label
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_11, _toDisplayString(session.description), 1),
                      _hoisted_12
                    ], 512), [
                      [_vShow, session.description]
                    ]),
                    _createVNode(_component_Fields, {
                      fields: session.fields
                    }, null, 8, ["fields"])
                  ]),
                  _: 2
                }, 1032, ["dropdown", "title-subsession"]))
              }), 128))
            ], 544))
      ])
    ])
  ], 512))
}